import EastIcon from '@mui/icons-material/East'
import { Box, Container,Grid,Divider } from '@mui/material'
import { AlertColor } from '@mui/material/Alert'
import { usePostPayment } from '@src/api/payment-api/add-payment-api'
import { useGetActivePersonLoan } from '@src/api/person-api'
import NotificationContainer from '../Home/components/NotificationContainer'
import { CustomButton, CustomCheckboxLabel, PageSpinner, PaymentForm, TitleSection,CustomSnackbar } from '@src/components'
import { handleAmountChange } from '@src/services/Formatter'
import { ChangeEvent, useState, SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useMaxPaymentAmount,useInitializePaymentAmount } from '../../data/selectors/payment-amount-selector';

const AddPayment = () => {
  const { id } = useParams<{ id: string | undefined }>()
  const { t } = useTranslation()

  const [date, setDate] = useState<Date | null>(null)
  const [agreeToTerms, setAgreeToTerms] = useState(false)
  const [dollars, setDollars] = useState('')
  const [cents, setCents] = useState('')
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  })
  const [activeLoan, activeLoanId, isLoading] = useGetActivePersonLoan(id);
  const maxPaymentAmount = useMaxPaymentAmount(activeLoan);

  const [submitPayment, isPending] = usePostPayment()
  useInitializePaymentAmount(activeLoan, setDollars, setCents);
  
  const NotificationContainerProps = {
    lateAmountWithInterest: activeLoan?.lateAmountWithInterest?.toString() ?? '0',
    hideButton: true
  }

  const handleSubmit = () => {
    const totalAmount = parseFloat(handleAmountChange(dollars, cents));
    if (!date || !agreeToTerms || !activeLoanId) {
      setSnackbar({
        open: true,
        message: t('payment.allFieldsMustBeFilled'),
        severity: 'error',
      });
      return;
    }
    if (totalAmount > maxPaymentAmount) {
      setSnackbar({
        open: true,
        message: t('payment.amountExceedsAllowedBalance'),
        severity: 'error',
      });
      return;
    }

    submitPayment({
      amount: parseFloat(handleAmountChange(dollars, cents)),
      actualDate: date.toISOString(),
      newDate: date.toISOString(),
      contactCustomer: false,
      loanId: activeLoanId,
    })
      .then(() => {
        setSnackbar({
          open: true,
          message: t('payment.paymentSuccessfullyCreated'),
          severity: 'success',
        });
      })
      .catch(() => {
        setSnackbar({
          open: true,
          message: t('payment.allFieldsMustBeFilled'),
          severity: 'error',
        });
      })
  }
  const handleCloseSnackbar = (_event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar((prevState) => ({
      ...prevState,
      open: false,
    }));
  }
  const handleAgreeToTermsChange = (event: ChangeEvent<HTMLInputElement>) => {
    setAgreeToTerms(event.target.checked)
  }

  if (isLoading) return <PageSpinner isLoading={true} />

  const isSubmitDisabled = !agreeToTerms || !date


  return (
    <>
     <Box sx={{ mb: 2 }}>
        <Container>
          <Box
            sx={{
              padding: { xs: '0 1px', sm: '0 20px', mb: 2 },
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <NotificationContainer {...NotificationContainerProps} />
          </Box>
        </Container>
        { parseFloat(activeLoan?.lateAmountWithInterest?.toString()|| '0') > 0  && <Divider sx={{ bgcolor: 'grey.900',mb:3 }} />}
      </Box>
    <TitleSection title={t('payment.titleap')} />
    <Container component="main" sx={{ flexGrow: 1 }}>
    <Grid container>
      <Grid size={{ xs: 12, md: 9, lg: 9 }}>
      <Box sx={{ padding: { xs: '0 1px', sm: '0 20px',},boxSizing: 'border-box',}} >

        <PaymentForm
          selectedDate={date}
          dollars={dollars}
          cents={cents}
          onDollarsChange={setDollars}
          onCentsChange={setCents}
          onAgreeToTermsChange={handleAgreeToTermsChange}
          onDateChange={setDate}
        />
        <CustomCheckboxLabel
          checked={agreeToTerms}
          label={t('payment.confirmTerms')}
          onChange={handleAgreeToTermsChange}
        />

        <CustomButton
          disabled={isSubmitDisabled}
          title={t('payment.titleap')}
          onClick={handleSubmit}
          Icon={EastIcon}
          isPending={isPending}
        />
      </Box>
    </Grid>
     </Grid>
     </Container>
     <CustomSnackbar
      open={snackbar.open}
      message={snackbar.message}
      severity={snackbar.severity as AlertColor}
      onClose={handleCloseSnackbar}
    />
     </>
  )
}

export default AddPayment
